import { useEffect, useState } from 'react';

/**
 * Subscribes to a CSS media query.
 * Coach calendar mobile breakpoint: viewport width strictly less than 768px (Tailwind `md`).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const onChange = () => setMatches(mediaQueryList.matches);

    onChange();
    mediaQueryList.addEventListener('change', onChange);
    return () => mediaQueryList.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Viewport width < 768px — matches AC "less than 768px" and Tailwind `md`. */
export const MOBILE_MAX_WIDTH_MEDIA_QUERY = '(width < 768px)';
